import React from 'react';
import { Check } from 'lucide-react';
import { whyUs } from '../data/mock';
import { ScrollReveal, CountUp } from './ScrollAnimations';

const WhySection = () => {
  return (
    <section id="why" className="relative bg-[#050505] py-32 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.02]" />
      <div className="absolute top-1/2 left-0 w-[600px] h-[600px] bg-accent/5 rounded-full blur-[200px] -translate-y-1/2" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <ScrollReveal animation="fadeRight">
              <span className="text-accent text-sm font-medium tracking-wider uppercase mb-4 block">
                Pourquoi Webysee
              </span>
            </ScrollReveal>
            <ScrollReveal animation="fadeRight" delay={100}>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6 leading-tight">
                L'excellence digitale au service de votre{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-violet-400">
                  succès
                </span>
              </h2>
            </ScrollReveal>
            <ScrollReveal animation="fadeRight" delay={200}>
              <p className="text-white/50 text-lg mb-10 leading-relaxed">
                Nous ne créons pas simplement des sites web, nous construisons des expériences digitales qui transforment vos visiteurs en clients fidèles.
              </p>
            </ScrollReveal>

            <ScrollReveal animation="fadeUp" delay={300}>
              <div className="flex flex-col sm:flex-row gap-6">
                <div className="text-center sm:text-left">
                  <div className="text-4xl font-bold text-accent mb-2">
                    <CountUp end={100} suffix="+" duration={2000} />
                  </div>
                  <div className="text-white/50 text-sm">Projets réalisés</div>
                </div>
                <div className="hidden sm:block w-px bg-white/10" />
                <div className="text-center sm:text-left">
                  <div className="text-4xl font-bold text-accent mb-2">
                    <CountUp end={98} suffix="%" duration={2000} />
                  </div>
                  <div className="text-white/50 text-sm">Clients satisfaits</div>
                </div>
                <div className="hidden sm:block w-px bg-white/10" />
                <div className="text-center sm:text-left">
                  <div className="text-4xl font-bold text-accent mb-2">
                    <CountUp end={5} suffix="+" duration={1500} />
                  </div>
                  <div className="text-white/50 text-sm">Années d'expérience</div>
                </div>
              </div>
            </ScrollReveal>
          </div>

          {/* Right - Features List */}
          <div className="space-y-6">
            {whyUs.map((item, index) => (
              <ScrollReveal
                key={item.id}
                animation="fadeLeft"
                delay={index * 100}
                className="group flex gap-4 p-6 bg-white/[0.02] border border-white/[0.05] hover:border-accent/20 hover:bg-white/[0.04] transition-all duration-500"
              >
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-accent/10 text-accent group-hover:bg-accent group-hover:text-black transition-all duration-500">
                  <Check size={20} />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white mb-1 group-hover:text-accent transition-colors duration-300">
                    {item.title}
                  </h3>
                  <p className="text-white/50 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
